// Theme toggle (D38, control simplified 2026-09-17) — one button in the shell's
// sidebar footer. It flips to the opposite of the theme currently showing;
// lib/theme.tsx decides whether that choice is stored or, when it matches the
// OS, cleared so the page follows the OS again (ui/DESIGN.md §3).
//
// Accessibility (ui/DESIGN.md §10): a real <button>, so the keyboard, the
// Enter/Space contract and the base-layer focus ring come from the platform, and
// `size="icon"` is the 44px target. The icon is decorative — the state reaches
// assistive tech through the accessible name, never through the glyph or its
// colour. That name states the ACTION and flips with the theme, so a reader
// hears what the press will do rather than where they are. No aria-pressed: the
// name already answers that question, and a pressed state would contradict it
// half the time. No tooltip — it is not a label.

import { Button, Glyph } from "@/ui";
import { useTheme } from "@/lib/theme";

export function ThemeControl() {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={dark ? "Ganti ke tema terang" : "Ganti ke tema gelap"}
    >
      <Glyph name="theme" />
    </Button>
  );
}
